export default __webpack_public_path__ + "static/media/Baha-Eryurekliler.a0414eac.png";